// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { Tag } from './tag.zod.ts';

export const AssetCard = zod.object({
  "countries": zod.array(zod.string()),
  "home_country": zod.string(),
  "id": zod.uuid(),
  "industries": zod.array(Tag),
  "kind": zod.string(),
  "last_confirmed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "maturity": zod.string(),
  "name": zod.string(),
  "partners": zod.array(Tag),
  "rank": zod.union([zod.number(),zod.null()]),
  "stale": zod.boolean(),
  "status": zod.string(),
  "summary": zod.string(),
  "tagline": zod.string(),
  "updated_at": zod.iso.datetime({"offset":true})
});

export type AssetCard = zod.input<typeof AssetCard>;
export type AssetCardOutput = zod.output<typeof AssetCard>;
